<template>
  <div class="point_purchase">
    <section class="text_center">
      <h2 class="header_underline">鑑定ポイント購入</h2>
    </section>
    <point-purchase-list :info="info" />
  </div>
</template>

<script>
import PointPurchaseList from '@/components/point/PointPurchaseList'

export default {
  name: 'PointPurchase',
  components: {
    PointPurchaseList
  },
  data () {
    return {
      info: this.$store.getters.siteInfo || null
    }
  },
  computed: {
    siteInfo () {
      return this.$store.getters.siteInfo
    }
  },
  watch: {
    siteInfo (val, old) {
      this.info = val
    }
  }
}
</script>
